import { paths } from '../index'

export const ONBOARDING = 'onboarding'
export * from './get-onboarder'

export const onboardingPaths = {
  onboardings: (organization) => `${paths.organization(organization)}/onboarding`,
  onboarding: (organization, account) => `${onboardingPaths.onboardings(organization)}/${account}`
}
